(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"]) return;
  try {
    
  (() => {
    const update = (toggle) => {
      const description = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!description || description.classList.contains('is-expanded')) return;
      toggle.hidden = description.scrollHeight <= description.clientHeight + 1;
    };

    const init = () => {
      document.querySelectorAll('.collection-description__toggle').forEach((toggle) => {
        if (toggle.dataset.bound) return;
        toggle.dataset.bound = 'true';

        toggle.addEventListener('click', () => {
          const description = document.getElementById(toggle.getAttribute('aria-controls'));
          const expanded = description.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? toggle.dataset.less : toggle.dataset.more;
        });

        update(toggle);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('resize', () => document.querySelectorAll('.collection-description__toggle').forEach(update));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    // Separate on/off thresholds: shrinking the header moves content (scroll anchoring), which would otherwise flicker around one value
    let scrolled = false;
    const update = () => {
      if (!scrolled && window.scrollY > 120) scrolled = true;
      else if (scrolled && window.scrollY < 10) scrolled = false;
      else return;
      document.querySelectorAll('.header').forEach((header) => header.classList.toggle('is-scrolled', scrolled));
    };

    window.addEventListener('scroll', update, { passive: true });
    document.addEventListener('DOMContentLoaded', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();
})();
